import React, { useEffect, useState } from "react";
import {
  FormControlLabel,
  TextField,
  Tooltip
} from "@mui/material";
import { Button } from "@mui/material";
import CarpathIcon from "assets/svgIcons/CarPathIcon";
import EnableCarZoneIcon from "assets/svgIcons/Shutdown";
import CampasIcon from "assets/svgIcons/CampasIcon";
import FlagHoleIcon from "assets/svgIcons/FlagIcon";
import IconButton from "@mui/material/IconButton";
import FlagIcon from "assets/svgIcons/ActionZoneCarType/FlagCarIcon";
import Eye from "assets/svgIcons/Eye";
import ShildIcon from "assets/svgIcons/ActionZoneCarType/ShildCarIcon";
import ActionZoneAudioIcon from "assets/svgIcons/ActionZoneAudioIcon";
import SpecialNeedsIcon from "assets/svgIcons/CarType/SpecialNeeds";

import {
  getFeatureSetOption,
  getFeaturesList,
  isUserBasic,
  isUserReadOnly,
  featureKey,
  actionZoneTypes,
  deviceType,
  isUserAdmin,
  isUserSupport,
  siteFleetType,
  isFtPlusSite,
  canManageAzLimits,
  actionZoneLimits
} from "../../../../../../constant";
import DineIcon from "assets/svgIcons/ActionZoneCarType/F&BIcon";
import DirectionIcon from "assets/icons/direction-icon.png";
import LeftRotateIcon from "assets/icons/left-rotate-icon.png";
import RightRotateIcon from "assets/icons/right-rotate-icon.png";
import PictureIcon from "assets/svgIcons/CameraIcon";
import SettingIcon from "assets/images/setting-icon.png";
import UnMuteIcon from "assets/svgIcons/UnMuteIcon";
import MuteIcon from "assets/svgIcons/MuteIcon";
import RuleImg from "assets/images/rule.png";
import { SelectContainer } from "commonComponents/FormElement/Select/SelectStyled";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuItem from "@mui/material/MenuItem";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { PopUpContainer } from "assets/css/globle";
import moment from "moment";
import FilterCarIcon from "assets/svgIcons/FilterCarIcon";

import {
  Container,
  EnableZone,
  CarType,
  MuteSection,
  DirectionSection,
  StyledWrapper,
  TextAreaStyled,
  ToggleIconWrapper,
  SaveActionWrapper,
  Rule90,
  HoleFlagWrapper,
  CourseStyle
} from "commonComponents/SideNav/subSectionNav/Map/ActionZone/ActionZonesSubNav/ActionZonesSubNavStyled";

import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import {
  MAP_GLOBAL_STATES,
  SITEID_GLOBAL_STATE,
  SiteSetupAction
} from "globalStore/globalStore";

import { useHookstate } from "@hookstate/core";
import Checkbox from "@mui/material/Checkbox";
import { useTranslation } from "react-i18next";
import MembercarIcon from "assets/svgIcons/CarType/MembercarIcon";
import CheckIcon from "assets/svgIcons/CheckIcon";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import { CheckBoxWrapper, DateWrapper, StartEndDate, WorkSection } from "pages/Fleet/Scorecards/ScorecardsStyled";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import TimeIcon from "assets/svgIcons/TimeIcon";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { isAfter, isBefore, isEqual } from "date-fns";
import WarningIcon from "@mui/icons-material/Warning";

const labelText = { inputProps: { "aria-label": "Checkbox demo" } };
const ActionZonesSubNav = React.memo(function () {
  //get site dropdown options
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [selectedImageId, setSelectedImageId] = useState("");
  const [selectedImageName, setSelectedImageName] = useState("");
  const [imgAvailable, setImgAvailable] = useState(true);
  const [selectedCourse, setSelectedCourse] = useState(1);
  const [holeCount, setHoleCount] = useState(0);
  const [selectedHole, setSelectedHole] = useState(1);
  const [handicappedCar, setHandicappedCar] = useState(false);
  const [fleetCar, setFleetCar] = useState(true);
  const [memberCar, setMemberCar] = useState(false);
  const [memberCarSpecialNeeds, setMemberCarSpecialNeeds] = useState(false);
  const [showVdu, setShowVdu] = useState(false);
  const [alertOnEnter, setAlertOnEnter] = useState(false);
  const [marshalCar, setMarshalCar] = useState(false);
  const [beverageCar, setBeverageCar] = useState(false);
  const [activationDirection, setActivationDirection] = useState(0);
  const [useDirection, setUseDirection] = useState(false);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [actionZoneMessage, setActionZoneMessage] = useState("");
  const [actionZoneLabel, setActionZoneLabel] = useState("Action zone");
  const [isBeepOn, setIsBeepOn] = useState(true);
  const [actionZoneIsGeofence, setActionZoneIsGeofence] = useState(false);
  const [actionZoneHoles, setActionZoneHoles] = useState([]);
  const [isCommercial, setIsCommercial] = useState(false);
  const [allMetMinVersion, setAllMetMinVersion] = useState(false);
  const [enforceTime, setEnforceTime] = useState(false);
  const [vaildationMsg, setValidationMsg] = useState("");
  const [messageSettings, setMessageSettings] = useState([]);
  const [hasShownLimitPopup, setHasShownLimitPopup] = useState(false);

  const {
    actionZoneIsCartPathOnly,
    isEnabledActionZone,
    openActionZoneWindow,
    editActionZonePolygonData,
    editActionZonePolygonVertices,
    addActionZonePolygon,
    loadingOnProcess,
    actionZoneModified,
    actionZoneId,
    optionsCPOShowCourses,
    courseExtents,
    actionZoneAction,
    cancelActionZoneEdit,
    actionZoneRequest,
    saveActionZone,
    deleteActionZone,
    actionZoneVertexCount,
    lastSelectedActionZoneImageId,
    azLimitPopupOpen,
    azLimitPopupMessage
  } = useHookstate(MAP_GLOBAL_STATES);

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const { fleetType } = useHookstate(SiteSetupAction);

  const directionDisabled = -1;
  const rotationIncrement = 22.5;    // must be evenly divisible into 360

  const rotateButtonsStyle = {
    border: '1px solid #ccc',
    padding: '5px 5px 1px 5px',
    borderRadius: '4px'
  }

  const rotateButtonsDisabledStyle = {
    border: '1px solid #ccc',
    padding: '5px 5px 1px 5px',
    borderRadius: '4px',
    opacity: '.65'
  }

  const {
    siteSettingsData,
    siteSettingsData: { DistanceUnits },
    getImageGalleryData,
    getAdImageData,
    getUserRole,
    getCarsData,
    getMinVersForNewAZsData,
    getCarPathActionZone
  } = useSelector((state) => { return state.commonReducers; }) || [];

  const totalActionZones = getCarPathActionZone?.length ?? 0;

  const { MAX_VERTICES, VERTEX_WARNING_THRESHOLD, MAX_ACTION_ZONES, ZONE_WARNING_THRESHOLD } = actionZoneLimits;

  const isAzLimitSite = isFtPlusSite(fleetType.get()) && canManageAzLimits(getUserRole && getUserRole?.Role);

  const vertexCount = actionZoneVertexCount.get();
  const isOverVertexLimit = isAzLimitSite && vertexCount > MAX_VERTICES;
  const isNearVertexLimit = isAzLimitSite && vertexCount >= VERTEX_WARNING_THRESHOLD && vertexCount <= MAX_VERTICES;
  const isOverZoneLimit = isAzLimitSite && totalActionZones > MAX_ACTION_ZONES;
  const isNearZoneLimit = isAzLimitSite && totalActionZones >= ZONE_WARNING_THRESHOLD && totalActionZones < MAX_ACTION_ZONES;
  const isOverAnyLimit = isOverVertexLimit || isOverZoneLimit;

  const redBorderStyle = () => {
    if (isOverAnyLimit) {
        return { border: '4px solid #d32f2f' };//at az limit
    }
    if (showNearingWarning) {
        return { border: '4px solid #ed3902' };//near az limit
    }
    return {};
};

  const showNearingWarning = !isOverAnyLimit && (isNearVertexLimit || isNearZoneLimit);
  const nearingWarningMessage = isNearVertexLimit
    ? `You are nearing max number allowed for vertices for this action zone:${MAX_VERTICES}`
    : `You are nearing max number allowed for action zone: ${MAX_ACTION_ZONES}`;
  const enableMemberCar = (isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) || !getFeatureSetOption(
    siteSettingsData?.Features,
    getFeaturesList().member_cars
  ));

  const isRestrictedUser =
    isUserBasic(getUserRole && getUserRole?.Role) ||
    isUserReadOnly(getUserRole && getUserRole?.Role);

  useEffect(() => {
  if (isOverAnyLimit && !hasShownLimitPopup) {
    const msg = isOverVertexLimit
      ? `Reduce number of vertices from ${vertexCount} to ${MAX_VERTICES} or below`
      : `Reduce number of action zones from ${totalActionZones} to ${MAX_ACTION_ZONES} or below`;
    azLimitPopupMessage.set(msg);
    azLimitPopupOpen.set(true);
    setHasShownLimitPopup(true);
  }
  if (!isOverAnyLimit) {
    setHasShownLimitPopup(false);
  }
}, [isOverVertexLimit, isOverZoneLimit, vertexCount, totalActionZones]);

  let vduElectricMessageSettings = [
    {
      val: 6,
      txt: t("Message_only"),
      mph: null,
      kph: null
    },
    {
      val: 1,
      txt: t("Complete_stop"),
      mph: null,
      kph: null
    },
    {
      val: 2,
      txt: t("Stop_and_reverse"),
      mph: null,
      kph: null
    },
    {
      val: 3,
      txt: null,
      mph: t("Limit_to_2_mph"),
      kph: t("Limit_to_3_kph")
    },
    {
      val: 7,
      txt: null,
      mph: t("Limit_to_3_mph"),
      kph: t("Limit_to_5_kph")
    },
    {
      val: 8,
      txt: null,
      mph: t("Limit_to_4_mph"),
      kph: t("Limit_to_6_kph")
    },
    {
      val: 9,
      txt: null,
      mph: t("Limit_to_5_mph"),
      kph: t("Limit_to_8_kph")
    },
    {
      val: 10,
      txt: null,
      mph: t("Limit_to_6_mph"),
      kph: t("Limit_to_10_kph")
    },
    {
      val: 4,
      txt: null,
      mph: t("Limit_to_7_mph"),
      kph: t("Limit_to_11_kph")
    },
    {
      val: 11,
      txt: null,
      mph: t("Limit_to_8_mph"),
      kph: t("Limit_to_13_kph")
    },
    {
      val: 12,
      txt: null,
      mph: t("Limit_to_9_mph"),
      kph: t("Limit_to_14_kph")
    },
    {
      val: 5,
      txt: null,
      mph: t("Limit_to_10_mph"),
      kph: t("Limit_to_16_kph")
    },
  ];

  let vduGasMessageSettings = [
    {
      val: 6,
      txt: t("Message_only"),
      mph: null,
      kph: null
    },
    {
      val: 1,
      txt: t("Complete_stop"),
      mph: null,
      kph: null
    },
    {
      val: 2,
      txt: t("Stop_and_reverse"),
      mph: null,
      kph: null
    }
  ];

  let ft2ElectricMessageSettings = [
    {
      val: 6,
      txt: t("Alert_only"),
      mph: null,
      kph: null
    },
    {
      val: 1,
      txt: t("Complete_stop"),
      mph: null,
      kph: null
    },
    {
      val: 2,
      txt: t("Stop_and_reverse"),
      mph: null,
      kph: null
    },
    {
      val: 3,
      txt: null,
      mph: t("Limit_to_2_mph"),
      kph: t("Limit_to_3_kph")
    },
    {
      val: 7,
      txt: null,
      mph: t("Limit_to_3_mph"),
      kph: t("Limit_to_5_kph")
    },
    {
      val: 8,
      txt: null,
      mph: t("Limit_to_4_mph"),
      kph: t("Limit_to_6_kph")
    },
    {
      val: 9,
      txt: null,
      mph: t("Limit_to_5_mph"),
      kph: t("Limit_to_8_kph")
    },
    {
      val: 10,
      txt: null,
      mph: t("Limit_to_6_mph"),
      kph: t("Limit_to_10_kph")
    },
    {
      val: 4,
      txt: null,
      mph: t("Limit_to_7_mph"),
      kph: t("Limit_to_11_kph")
    },
    {
      val: 11,
      txt: null,
      mph: t("Limit_to_8_mph"),
      kph: t("Limit_to_13_kph")
    },
    {
      val: 12,
      txt: null,
      mph: t("Limit_to_9_mph"),
      kph: t("Limit_to_14_kph")
    },
    {
      val: 5,
      txt: null,
      mph: t("Limit_to_10_mph"),
      kph: t("Limit_to_16_kph")
    },
  ];

  let ft2GasMessageSettings = [
    {
      val: 6,
      txt: t("Alert_only"),
      mph: null,
      kph: null
    },
    {
      val: 2,
      txt: t("Stop_15s_Run_30s"),
      mph: null,
      kph: null
    }
  ];

  let mixedMessageSettings = [
    {
      val: 6,
      txt: fleetType.get() == siteFleetType.ft2Mixed ? t("Alert_only") : t("Message_only"),
      mph: null,
      kph: null
    },
    {
      val: 1,
      txt: t("Complete_stop"),
      mph: null,
      kph: null
    },
    {
      val: 2,
      txt: t("Stop_and_reverse"),
      mph: null,
      kph: null
    },
    {
      val: 3,
      txt: null,
      mph: t("Limit_to_2_mph"),
      kph: t("Limit_to_3_kph")
    },
    {
      val: 7,
      txt: null,
      mph: t("Limit_to_3_mph"),
      kph: t("Limit_to_5_kph")
    },
    {
      val: 8,
      txt: null,
      mph: t("Limit_to_4_mph"),
      kph: t("Limit_to_6_kph")
    },
    {
      val: 9,
      txt: null,
      mph: t("Limit_to_5_mph"),
      kph: t("Limit_to_8_kph")
    },
    {
      val: 10,
      txt: null,
      mph: t("Limit_to_6_mph"),
      kph: t("Limit_to_10_kph")
    },
    {
      val: 4,
      txt: null,
      mph: t("Limit_to_7_mph"),
      kph: t("Limit_to_11_kph")
    },
    {
      val: 11,
      txt: null,
      mph: t("Limit_to_8_mph"),
      kph: t("Limit_to_13_kph")
    },
    {
      val: 12,
      txt: null,
      mph: t("Limit_to_9_mph"),
      kph: t("Limit_to_14_kph")
    },
    {
      val: 5,
      txt: null,
      mph: t("Limit_to_10_mph"),
      kph: t("Limit_to_16_kph")
    },
  ];

  const deleteModalPopupStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 444,
    bgcolor: "background.paper",
    boxShadow: 24,
    width: "100%",
    background: "#FFFFFF",
    boxShadow: "0px 14px 100px 30px rgba(0, 0, 0, 0.3)",
    borderRadius: "4px",
    outline: "none",
  };
  const defaultTime = new Date(2000, 0, 1, 0, 0, 0);
  const [times, setTimes] = useState({
    timeStart0: defaultTime,
    timeEnd0: defaultTime,
    timeStart1: defaultTime,
    timeEnd1: defaultTime
  })

  useEffect(() => {
    dispatch(COMMON_SERVICES.getMinVersForNewAZsService());
  }, []);

  useEffect(() => {
    var determineMessageSettings = mixedMessageSettings;

    if (fleetType.get() == siteFleetType.vduElectric) {
      determineMessageSettings = vduElectricMessageSettings;
    } else if (fleetType.get() == siteFleetType.vduGas) {
      determineMessageSettings = vduGasMessageSettings;
    } else if (fleetType.get() == siteFleetType.ft2Electric) {
      determineMessageSettings = ft2ElectricMessageSettings;
    } else if (fleetType.get() == siteFleetType.ft2Gas) {
      determineMessageSettings = ft2GasMessageSettings;
    }

    setMessageSettings(determineMessageSettings);
  }, [fleetType.get()]);

  useEffect(() => {
    if (Object.keys(getCarsData).length > 0 && getMinVersForNewAZsData && Object.keys(getMinVersForNewAZsData).length > 0) {
      let minSWforNewAZsLT = getMinVersForNewAZsData.find(x => x.setting == "LT").value;
      let minSWforNewAZsVDU = getMinVersForNewAZsData.find(x => x.setting == "VDU").value;

      const metMinVers = getCarsData.every((c) => {
        if (c.Car.DevType === deviceType.G2 ||
          c.Car.DevType === deviceType.VDU ||
          c.Car.DevType === deviceType.VDU21) {
          return false;
        }
        if (c.Car.DevType === deviceType.FT) {
          return true;
        }
        if (c.Car.DevType === deviceType.VDU3 ||
          c.Car.DevType === deviceType.VDU4) {
          return c.Car.SWversion != null && // Checks for both null and undefined
            c.Car.SWversion >= minSWforNewAZsVDU;
        }
        if (c.Car.DevType === deviceType.LT) {
          return c.Car.SWversion != null && // Checks for both null and undefined
            c.Car.SWversion >= minSWforNewAZsLT;
        }
        return false;
      });

      setAllMetMinVersion(metMinVers);
    } else {
      setAllMetMinVersion(false);
    }
  }, [getCarsData, getMinVersForNewAZsData]);

  useEffect(() => {
    setIsCommercial(siteSettingsData?.Features?.indexOf(featureKey.resortEdition) >= 0)
  }, [siteId.get(), siteSettingsData]);

  useEffect(() => {
    return () => {
      openActionZoneWindow.set(false);
    };
  }, []);

  useEffect(() => {
    if (Object.keys(editActionZonePolygonData).length > 0) {
      isImageAvailable(editActionZonePolygonData.get().actionZoneInfo?.ImageId);
    }
  }, [getImageGalleryData]);

  //getCurrentActionZoneInfo dealt here
  useEffect(() => {
    if (getImageGalleryData == null || getImageGalleryData?.length === 0) {
      dispatch(COMMON_SERVICES.getImageGalleryServices(siteId.get()));
    }
    const convertTime = (time) => {
      return moment.utc(time).utcOffset(-siteSettingsData?.TimeZoneOffset);
    }
    if (editActionZonePolygonData.get()?.actionZoneInfo?.Id) {
      setActionZoneMessage(editActionZonePolygonData.get()?.actionZoneInfo?.Message);

      isEnabledActionZone.set(editActionZonePolygonData?.get()?.actionZoneInfo?.IsEnabled ?? false);
      setMarshalCar(editActionZonePolygonData.get()?.actionZoneInfo?.IsEnforcedForMarshal);
      setHandicappedCar(editActionZonePolygonData.get()?.actionZoneInfo?.IsEnforcedForHandicapped);
      setBeverageCar(editActionZonePolygonData.get()?.actionZoneInfo?.IsEnforcedForBeverage);
      setMemberCar(editActionZonePolygonData.get()?.actionZoneInfo?.IsEnforcedForMemberCars);
      setMemberCarSpecialNeeds(editActionZonePolygonData.get()?.actionZoneInfo?.IsEnforcedForMemberCarSpecial);
      setFleetCar(editActionZonePolygonData.get()?.actionZoneInfo?.IsEnforcedForGolf);
      setEnforceTime(editActionZonePolygonData.get()?.actionZoneInfo?.EnforceTimeRestriction);
      if (editActionZonePolygonData.get()?.actionZoneInfo?.EnforceTimeRestriction) {
        var startDt0 = convertTime(editActionZonePolygonData.get()?.actionZoneInfo?.TimeStart0);
        var endDt0 = convertTime(editActionZonePolygonData.get()?.actionZoneInfo?.TimeEnd0);
        var startDt1 = convertTime(editActionZonePolygonData.get()?.actionZoneInfo?.TimeStart1);
        var endDt1 = convertTime(editActionZonePolygonData.get()?.actionZoneInfo?.TimeEnd1);

        setTimes({
          timeStart0: new Date(2000, 0, 1, startDt0.hour(), startDt0.minute(), 0),
          timeEnd0: new Date(2000, 0, 1, endDt0.hour(), endDt0.minute(), 0),
          timeStart1: new Date(2000, 0, 1, startDt1.hour(), startDt1.minute(), 0),
          timeEnd1: new Date(2000, 0, 1, endDt1.hour(), endDt1.minute(), 0)
        });
      }
      else {
        setTimes({
          timeStart0: defaultTime,
          timeEnd0: defaultTime,
          timeStart1: defaultTime,
          timeEnd1: defaultTime
        });
      }
      setIsBeepOn(editActionZonePolygonData.get()?.actionZoneInfo?.IsBeepInActionZone);
      setAlertOnEnter(editActionZonePolygonData.get()?.actionZoneInfo?.IsAlertOnEnter);
      setShowVdu(editActionZonePolygonData.get()?.actionZoneInfo?.IsShowOnVDU);
      setActionZoneLabel(editActionZonePolygonData.get()?.actionZoneInfo?.Label);

      let localSelectedCourse = editActionZonePolygonData.get()?.actionZoneInfo?.Course;
      setSelectedCourse(localSelectedCourse === 0 ? 1 : localSelectedCourse);

      actionZoneIsCartPathOnly.set(editActionZonePolygonData.get()?.actionZoneInfo?.IsCartPathOnly);

      setActionZoneIsGeofence(editActionZonePolygonData.get()?.actionZoneInfo?.IsGeofence);
      actionZoneAction.set(editActionZonePolygonData.get()?.actionZoneInfo?.Type);
      setActivationDirection(editActionZonePolygonData.get()?.actionZoneInfo?.ActivationDirection);
      setUseDirection(editActionZonePolygonData?.get()?.actionZoneInfo?.ActivationDirection >= 0);

      setSelectedImageId(editActionZonePolygonData.get()?.actionZoneInfo?.ImageId);
      setSelectedImageName(editActionZonePolygonData.get()?.actionZoneInfo?.ImageFilename);

      // set the hole count for this action zone
      handleHoleCount();

      setSelectedHole(editActionZonePolygonData.get()?.actionZoneInfo?.Hole === 0 && actionZoneIsCartPathOnly.get() ? 1 : editActionZonePolygonData.get()?.actionZoneInfo?.Hole);

      actionZoneVertexCount.set(editActionZonePolygonVertices.get().length);

      if (editActionZonePolygonData.get()?.actionZoneInfo?.ImageId) {
        dispatch(COMMON_SERVICES.resetGetAdImageDataServices());
        dispatch(
          COMMON_SERVICES.getAdImageServices({
            id: editActionZonePolygonData.get()?.actionZoneInfo?.ImageId,
          })
        );
      } else {
        setSelectedImageId("");
        dispatch(COMMON_SERVICES.resetGetAdImageDataServices());
      }
    } else {
      isEnabledActionZone.set(true);
      actionZoneIsCartPathOnly.set(false);
      setAlertOnEnter(false);
      setIsBeepOn(true);
      setMemberCar(false);
      setMemberCarSpecialNeeds(false);
      setBeverageCar(false);
      setHandicappedCar(false);
      setMarshalCar(false);
      setSelectedCourse(1);
      actionZoneAction.set(actionZoneTypes.NoSpeedRestriction);
      setActionZoneMessage("");
      setActionZoneLabel("Action zone");
      setUseDirection(false);
      setActivationDirection(0);
      setSelectedImageId("");
      setSelectedImageName("");
      dispatch(COMMON_SERVICES.resetGetAdImageDataServices());
    }
  }, [editActionZonePolygonData.get() && editActionZonePolygonData.get()?.actionZoneInfo?.Id]);

  const handleHoleCount = () => {
    let localHoleCount = holeCount;

    let localSelectedCourse = editActionZonePolygonData.get()?.actionZoneInfo?.Course === 0 ? 1 : editActionZonePolygonData.get()?.actionZoneInfo?.Course;

    if (courseExtents.get().length) {
      if (localSelectedCourse) {
        localHoleCount = courseExtents.get()[localSelectedCourse - 1]?.HoleCount;
      } else if (courseExtents.get()[0]?.HoleCount) {
        localHoleCount = courseExtents.get()[0]?.HoleCount;
      }
    }

    if (courseExtents.get().length === 0 || !localHoleCount || localHoleCount === 0)
      localHoleCount = 18;

    setHoleCount(localHoleCount);

    // populate the hole array for this action zone
    let localActionZoneHoles = [];
    for (var i = 0; i < localHoleCount; i++) {
      localActionZoneHoles.push(i + 1);
    }

    setActionZoneHoles(localActionZoneHoles);
  }

  const handleChangeImage = (e) => {
    let imageId = e.target.value;

    dispatch(COMMON_SERVICES.resetGetAdImageDataServices());

    if (imageId) {
      dispatch(COMMON_SERVICES.getAdImageServices({ id: imageId }));
      isImageAvailable(imageId);
      setSelectedImageId(imageId);
      setSelectedImageName(getSiteImageById(imageId).filename);
      lastSelectedActionZoneImageId.set(imageId);
      actionZoneModified.set(true);
    }
    else {
      setSelectedImageId("");
      setSelectedImageName("");
      lastSelectedActionZoneImageId.set(null);
      actionZoneModified.set(true);
    }
  };

  const getSiteImageById = (imageId) => {
    if (imageId) {
      return getImageGalleryData.find((o) => o.id === imageId);
    }
  }

  const isImageAvailable = (imageId) => {
    let getImagedetails = getImageGalleryData.find((o) => o.id === imageId);

    setImgAvailable(getImagedetails !== undefined);
  }

  const handleChangeCourse = (e) => {
    setSelectedCourse(e.target.value);

    // If the course value changes, update the holes list for this AZ
    let localHoleCount = holeCount;
    if (siteSettingsData?.Courses?.length) {
      localHoleCount = siteSettingsData?.Courses[e.target.value - 1].HoleCount;

    } else {
      localHoleCount = 18;
    }

    setHoleCount(localHoleCount);
    let localActionZoneHoles = [];
    for (var i = 0; i < localHoleCount; i++) {
      localActionZoneHoles.push(i + 1);
    }
    setActionZoneHoles(localActionZoneHoles);

    actionZoneModified.set(true);
  };

  const handleChangeSetting = (e) => {
    actionZoneAction.set(e.target.value);
    actionZoneModified.set(true);
  };

  const handleToggleClick = (action) => {
    if (action === "unmute") {
      setIsBeepOn(true);
    } else {
      setIsBeepOn(false);
    }

    actionZoneModified.set(true);
  };

  const rotateImageLeft = () => {
    if (useDirection) {
      setActivationDirection(adjustedAngle(-rotationIncrement));
    }

    actionZoneModified.set(true);
  };

  const rotateImageRight = () => {
    if (useDirection) {
      setActivationDirection(adjustedAngle(rotationIncrement));
    }

    actionZoneModified.set(true);
  };

  const adjustedAngle = (delta) => {
    // Adjust by the "delta" amount and round to nearest "rotationIncrement" multiple
    var x = activationDirection + delta;
    x = Math.round(rotationIncrement * Math.round(x / rotationIncrement));
    if (x >= 360) x -= 360;
    if (x < 0) x += 360;
    return x;
  }

  const handleEnableActionZone = (e) => {
    isEnabledActionZone.set(e.target.checked);
    actionZoneIsCartPathOnly.set(false); // CPO AZs are enabled in CPO settings
    actionZoneModified.set(true);
  }

  const handleIsCartPathOnly = (e) => {
    // CPO AZs are enabled in CPO settings instead
    isEnabledActionZone.set(false);

    //disable directional attribute when CPO
    setUseDirection(false);
    setActivationDirection(directionDisabled);

    // populate the hole array for this action zone
    if (actionZoneHoles.length === 0)
      handleHoleCount();

    if (e.target.checked)
      setSelectedHole(1);

    actionZoneIsCartPathOnly.set(e.target.checked);
    actionZoneModified.set(true);
  }

  const handleActionZoneLabel = (e) => {
    setActionZoneLabel(e.target.value);
    actionZoneModified.set(true);
  }

  const handleAlertOnEnter = () => {
    setAlertOnEnter(!alertOnEnter);
    actionZoneModified.set(true);
  }

  const handleOnUseDirection = () => {
    setUseDirection(!useDirection);
    setActivationDirection(useDirection ? 0 : directionDisabled);

    actionZoneModified.set(true);
  }

  const handleOnHoleChange = (e) => {
    setSelectedHole(e.target.value);
    actionZoneModified.set(true);
  }

  const handleActionZoneMessage = (e) => {
    setActionZoneMessage(e.target.value);
    actionZoneModified.set(true);
  }

  const handleFleetCar = () => {
    setFleetCar(!fleetCar);
    actionZoneModified.set(true);
  }

  const handleMarshalCar = () => {
    setMarshalCar(!marshalCar);
    actionZoneModified.set(true);
  }

  const handleHandicappedCar = () => {
    setHandicappedCar(!handicappedCar);
    actionZoneModified.set(true);
  }

  const handleBeverageCar = () => {
    setBeverageCar(!beverageCar);
    actionZoneModified.set(true);
  }

  const handleMemberCar = () => {
    setMemberCar(!memberCar);
    actionZoneModified.set(true);
  }

  const handleMemberCarSpecialNeeds = () => {
    setMemberCarSpecialNeeds(!memberCarSpecialNeeds);
    actionZoneModified.set(true);
  }

  const handleDeleteZone = () => {
    deleteActionZone.set(true);
    loadingOnProcess.set(true);
    addActionZonePolygon.set(false);
  };

  const handleResetGeofenceZone = () => {
    deleteActionZone.set(false);
    loadingOnProcess.set(true);
    addActionZonePolygon.set(false);
  };

  const handleShowOnVdu = () => {
    actionZoneModified.set(true);
    setShowVdu(!showVdu);
  }

  function validateTimeRange() {
    setValidationMsg('');
    const start0 = new Date(times.timeStart0);
    const end0 = new Date(times.timeEnd0);
    const start1 = new Date(times.timeStart1);
    const end1 = new Date(times.timeEnd1);
    if (enforceTime) {
      if (isEqual(end0, start0)) {
        return { valid: false, error: t('Err_Same_Time') };
      }
      if ((start0.getHours() >= 12 && end0.getHours() < 12) || (start1.getHours() >= 12 && end1.getHours() < 12)) {
        return { valid: false, error: t('Err_AMandPM') };
      }
      if (isBefore(end0, start0) || isBefore(end1, start1)) {
        return { valid: false, error: t('Err_EndGreater') };
      }
      if (isAfter(end1, start0) && isAfter(end0, start1)) {
        return { valid: false, error: t('Err_Overlap') };
      }
    }
    return { valid: true, error: "" };
  }
  const handleSaveZone = async () => {
    const convertTime = (time) => {
      var formattedTime = moment.utc('2000-01-01T00:00:00');
      formattedTime.hour(time.getHours()).minute(time.getMinutes());
      formattedTime.utcOffset(siteSettingsData.TimeZoneOffset);
      formattedTime.year(2000).month(0).date(1);
      return formattedTime.format('YYYY-MM-DDTHH:mm:ss.SSS');
    }
    let request = {
      Id: actionZoneId.get(),
      IsEnabled: isEnabledActionZone.get(),
      Type: actionZoneAction.get(),
      Message: actionZoneMessage,
      IsEnforcedForMarshal: marshalCar,
      IsEnforcedForHandicapped: handicappedCar,
      IsEnforcedForBeverage: beverageCar,
      IsEnforcedForMemberCars: memberCar,
      IsEnforcedForMemberCarSpecial: memberCarSpecialNeeds,
      IsEnforcedForGolf: fleetCar,
      EnforceTimeRestriction: enforceTime,
      TimeStart0: convertTime(times.timeStart0),
      TimeEnd0: convertTime(times.timeEnd0),
      TimeStart1: convertTime(times.timeStart1),
      TimeEnd1: convertTime(times.timeEnd1),
      IsBeepInActionZone: isBeepOn,
      ActivationDirection: useDirection ? activationDirection : directionDisabled,
      ImageFilename: selectedImageName,
      ImageId: selectedImageId,
      IsAlertOnEnter: alertOnEnter,
      IsShowOnVDU: showVdu,
      Label: actionZoneLabel,
      IsGeofence: actionZoneModified.get() ? editActionZonePolygonData?.get()?.actionZoneInfo?.IsGeofence : false,
      IsCartPathOnly: actionZoneIsCartPathOnly.get()
    }

    if (request.IsCartPathOnly && selectedCourse && selectedHole) {
      request.Course = actionZoneIsCartPathOnly.get() ? selectedCourse : 0;
      request.Hole = actionZoneIsCartPathOnly.get() ? selectedHole : 0;
    }
    var res = validateTimeRange();
    if (res?.valid) {
      //This triggers useEffect on MapComponent
      saveActionZone.set((prev) => !prev);
      actionZoneRequest.set(request);
      loadingOnProcess.set(true);
    }
    else
      setValidationMsg(res?.error);
  };

  return (
    <>
      {openActionZoneWindow.get() ? (
        <Container className="action-zone-sub-side-nav" style={redBorderStyle()}>
          <div className="action-zone-audio-wrapper">
            <input
              id="first"
              name="first"
              value={actionZoneLabel}
              onChange={(e) => handleActionZoneLabel(e)}
            />
            <Tooltip title={t("Alert_when_zone_entered")}>
              <button onClick={() => handleAlertOnEnter()}>
                <ActionZoneAudioIcon color={alertOnEnter ? "#a15e16" : "#000"} style={{
                  filter: "drop-shadow(0 0 0.6px currentColor)"
                }} />
              </button>
            </Tooltip>
          </div>

          <EnableZone>
            <div>
              <EnableCarZoneIcon />
              <p>{t("Enable_Action_Zone")}</p>
              <Checkbox
                {...labelText}
                checked={isEnabledActionZone.get()}
                onChange={(e) => handleEnableActionZone(e)}
                //MISSING > enabled={!actionZoneIsSizzleReel() || (actionZoneIsSizzleReel() && isUserAdminOrSupport())}
                sx={{
                  color: "#bc9b6a",
                  "&.Mui-checked": {
                    color: "#bc9b6a",
                  },
                }}
              />
            </div>
            {!actionZoneIsGeofence
              && (
                <div>
                  {isCommercial ? '*' : <CarpathIcon color="#636F7C" />}
                  <p>{isCommercial ? t("Place_Zone_in_AZ_group") : t("Use_Zone_for_Cart_Path_Only")}</p>
                  <Checkbox
                    {...labelText}
                    checked={actionZoneIsCartPathOnly.get()}
                    onChange={(e) => handleIsCartPathOnly(e)}
                    sx={{
                      color: "#bc9b6a",
                      "&.Mui-checked": {
                        color: "#bc9b6a",
                      },
                    }}
                  />
                </div>
              )
            }
          </EnableZone>

          {!actionZoneIsCartPathOnly.get()
            && (
              <DirectionSection>
                <div>
                  <button
                    className={useDirection ? "direction-btn active" : "direction-btn"}
                    onClick={() => handleOnUseDirection()}
                  >
                    <CampasIcon />
                    {t("Direction")}
                  </button>
                </div>
                <div className="rotate-section">
                  <button
                    disabled={!useDirection}
                    style={useDirection ? rotateButtonsStyle : rotateButtonsDisabledStyle}
                    onClick={() => rotateImageLeft()}>
                    <Tooltip title={t("Rotate_left")}>
                      <img src={LeftRotateIcon} alt="RotateIcon" />
                    </Tooltip>
                  </button>
                  <button>
                    <img src={DirectionIcon} alt="DirectionIcon" style={{ transform: `rotate(${activationDirection}deg)` }} />
                  </button>
                  <button style={useDirection ? rotateButtonsStyle : rotateButtonsDisabledStyle}
                    onClick={() => { rotateImageRight(); }} >
                    <Tooltip title={t("Rotate_right")}>
                      <img src={RightRotateIcon} alt="RotateIcon" />
                    </Tooltip>
                  </button>
                </div>
              </DirectionSection>
            )}
          {actionZoneIsCartPathOnly.get() && (
            <CourseStyle>
              {optionsCPOShowCourses.get() &&
                <SelectContainer className="select">
                  <FormControl sx={{ m: 1, minWidth: 50 }} size="small">
                    <Select
                      value={selectedCourse}
                      onChange={(e) => handleChangeCourse(e)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      IconComponent={KeyboardArrowDownIcon}
                      defaultValue={1}
                    >
                      {siteSettingsData.Courses?.map((elem, i) => (
                        <MenuItem key={i} value={elem.Number}>
                          {elem.Name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </SelectContainer>
              }
              <HoleFlagWrapper>
                {optionsCPOShowCourses.get() && isCommercial ? '' : <FlagHoleIcon color="var(--border-color)" />}
                {optionsCPOShowCourses.get() ? '' : <span className="hole-text">{isCommercial ? 'AZ Group' : 'Hole'}</span>}
                <SelectContainer className="select">
                  <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                    <Select value={selectedHole === 0 && actionZoneIsCartPathOnly.get() ? 1 : selectedHole}
                      onChange={(e) => handleOnHoleChange(e)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      IconComponent={KeyboardArrowDownIcon}
                      defaultValue={1}
                    >
                      {actionZoneHoles.map((elementInArray, index) => (
                        <MenuItem key={index} value={elementInArray}>
                          {elementInArray}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </SelectContainer>
              </HoleFlagWrapper>
            </CourseStyle>
          )}

          <CarType>
            <p style={{ paddingBottom: "15px" }}>{t("Car_type")}</p>
            <div className="filter-wrap">
              <Tooltip title={t("Enforce_for_fleet_cars")}>
                <button onClick={() => handleFleetCar()}>
                  <FilterCarIcon
                    bgcolor={
                      fleetCar
                        ? "var(--theme-background)"
                        : "var(--theme-text)"
                    }
                    color={
                      fleetCar
                        ? "var(--theme-text)"
                        : "var(--theme-background)"
                    }
                    stroke="#947550"
                    rx={5.5}
                    x={0.5}
                    y={0.5}
                    height={29}
                    width={29}
                  />
                </button>
              </Tooltip>
              <Tooltip title={t("Enforce_for_special_needs_cars")}>
                <button onClick={() => handleHandicappedCar()}>
                  <FlagIcon
                    bgcolor={
                      handicappedCar
                        ? "var(--theme-background)"
                        : "var(--theme-text)"
                    }
                    color={
                      handicappedCar
                        ? "var(--theme-text)"
                        : "var(--theme-background)"
                    }
                  />
                </button>
              </Tooltip>

              <Tooltip title={t("Enforce_for_Marshal_cars")}>
                <button onClick={() => handleMarshalCar()}>
                  <ShildIcon
                    bgcolor={
                      marshalCar
                        ? "var(--theme-background)"
                        : "var(--theme-text)"
                    }
                    color={
                      marshalCar
                        ? "var(--theme-text)"
                        : "var(--theme-background)"
                    }
                  />
                </button>
              </Tooltip>

              <Tooltip title={t("Enforce_for_Beverage_cars")}>
                <button onClick={() => handleBeverageCar()}>
                  <DineIcon
                    bgcolor={
                      beverageCar
                        ? "var(--theme-background)"
                        : "var(--theme-text)"
                    }
                    color={
                      beverageCar
                        ? "var(--theme-text)"
                        : "var(--theme-background)"
                    }
                  />
                </button>
              </Tooltip>
              {enableMemberCar && <Tooltip title={t("Enforce_for_member_cars")}>
                <button onClick={() => handleMemberCar()}>
                  <MembercarIcon
                    width={30}
                    height={30}
                    stroke={"#947550"}
                    bg={memberCar ? "var(--theme-background)" : "var(--theme-text)"}
                    color={memberCar ? "var(--theme-text)" : "var(--theme-background)"}
                  />
                </button>
              </Tooltip>}
              {enableMemberCar && <Tooltip title={t("Enforce_for_special_needs_cars")}>
                <button onClick={() => handleMemberCarSpecialNeeds()}>
                  <div style={{ display: "inline-flex", gap: "1px" }}>
                    <MembercarIcon width={30} height={30} bg={memberCarSpecialNeeds ? "var(--theme-background)" : "var(--theme-text)"}
                      stroke={"#947550"} color={memberCarSpecialNeeds ? "var(--theme-text)" : "var(--theme-background)"} opacity={1} />
                    <SpecialNeedsIcon width={20} height={30} bg={memberCarSpecialNeeds ? "var(--theme-background)" : "var(--theme-text)"}
                      stroke={"#947550"} color={memberCarSpecialNeeds ? "var(--theme-text)" : "var(--theme-background)"} />
                  </div>
                </button>
              </Tooltip>}
            </div>
          </CarType>

          {(fleetType.get() == siteFleetType.vduElectric || fleetType.get() == siteFleetType.vduMixed || fleetType.get() == siteFleetType.mixed) &&
            <>
              <TextAreaStyled>
                <textarea
                  maxLength={182}
                  id="first"
                  name="first"
                  rows="3"
                  placeholder={t("Type_your_message")}
                  value={actionZoneMessage}
                  onChange={(e) => handleActionZoneMessage(e)}
                ></textarea>
              </TextAreaStyled>

              <StyledWrapper>
                <PictureIcon className="icon" width={18} height={15} />
                <SelectContainer className="select">
                  <FormControl
                    sx={{ m: 1, minWidth: 120, maxWidth: 298 }}
                    size="small"
                  >
                    <Select
                      value={imgAvailable ? selectedImageId : ""}
                      onChange={(e) => handleChangeImage(e)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <MenuItem key="noImage" value="">
                        None
                      </MenuItem>
                      {getImageGalleryData
                        .filter((img) => !getFeatureSetOption(siteSettingsData && siteSettingsData?.Features, getFeaturesList().adman_pro) ? img.fullPage : img.fullPage && img.shared)
                        ?.map((elem, i) => (
                          <MenuItem key={i} value={elem.id}>
                            {elem.description}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </SelectContainer>
              </StyledWrapper>
              {imgAvailable && getAdImageData.length > 0 && ((!getFeatureSetOption(siteSettingsData && siteSettingsData?.Features, getFeaturesList().adman_pro) && getImageGalleryData.filter(item => item.id === selectedImageId).length > 0) || ((getFeatureSetOption(siteSettingsData && siteSettingsData?.Features, getFeaturesList().adman_pro)) && getImageGalleryData.filter(item => item.id === selectedImageId && item.shared).length > 0)) && (
                <Rule90>
                  <img
                    src={getAdImageData && getAdImageData[0]?.base64data}
                    alt={RuleImg}
                  />
                </Rule90>
              )}

              <MuteSection>
                <ToggleIconWrapper>
                  <Tooltip title={t("Sound_alert")}>
                    <IconButton
                      className={isBeepOn ? "active" : ""}
                      aria-label="Sound alert"
                      onClick={() => handleToggleClick("unmute")}
                      disabled={actionZoneAction.get() !== actionZoneTypes.NoSpeedRestriction}
                    >
                      <UnMuteIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("Do_not_sound_alert")}>
                    <IconButton
                      className={!isBeepOn ? "active" : ""}
                      aria-label="Sound alert"
                      onClick={() => handleToggleClick("mute")}
                      disabled={actionZoneAction.get() !== actionZoneTypes.NoSpeedRestriction}
                    >
                      <MuteIcon />
                    </IconButton>
                  </Tooltip>
                </ToggleIconWrapper>
                <Tooltip title={t("Show_on_VDU")}>
                  <div className={showVdu ? "section-wrap active" : "section-wrap inactive"}>
                    <button
                      disabled={
                        isUserBasic(getUserRole && getUserRole?.Role) ||
                        isUserReadOnly(getUserRole && getUserRole?.Role)
                      }
                      style={{
                        backgroudColor: showVdu
                          ? "var(--theme-background)"
                          : "var(--theme-text)",
                      }}
                      onClick={() => handleShowOnVdu()}
                    >
                      <Eye
                        bgcolor={
                          showVdu ? "var(--theme-text)" : "var(--theme-background)"
                        }
                        color={
                          showVdu ? "var(--theme-background)" : "var(--theme-text)"
                        }
                      />
                    </button>
                  </div>
                </Tooltip>
              </MuteSection>
            </>
          }

          <StyledWrapper>
            <img className="icon" src={SettingIcon} alt="icon" />
            <SelectContainer className="select">
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <Select
                  value={actionZoneAction.get()}
                  onChange={(e) => handleChangeSetting(e)}
                  displayEmpty
                  disabled={getFeatureSetOption(siteSettingsData && siteSettingsData?.Features, getFeaturesList().car_control)}
                  inputProps={{ "aria-label": "Without label" }}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  {
                    messageSettings?.map((elem, i) => (
                      <MenuItem key={i} value={elem.val}>
                        {elem.txt !== null ? elem.txt
                          : DistanceUnits === 1 ? elem.mph : DistanceUnits === 2 ? elem.kph
                            : ""}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </SelectContainer>
          </StyledWrapper>
          <WorkSection>
             <Tooltip title={enforceTime ? t("Does Not apply to FT+ (Screenless)"): ""} placement="bottom" arrow><CheckBoxWrapper style={{ marginBottom: "20px" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={enforceTime}
                    onChange={(e) => {
                      setEnforceTime(!enforceTime);
                      actionZoneModified.set(true);
                    }}
                    icon={<UnCheckIcon />}
                    checkedIcon={<CheckIcon />}
                  />
                }
                label={t("Enforce_for_fleet_hours")}
              />
            </CheckBoxWrapper></Tooltip>
            <DateWrapper>
              <StartEndDate>
                <p className="label">{t("Start")}</p>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MobileTimePicker
                    value={times.timeStart0}
                    disabled={!enforceTime}
                    onChange={(e) => {
                      setTimes(prev => ({
                        ...prev,
                        timeStart0: e
                      }));
                      actionZoneModified.set(true);
                    }}
                    minutesStep={15}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
                <TimeIcon />
              </StartEndDate>
              <StartEndDate>
                <p className="label">{t("End")}</p>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MobileTimePicker
                    value={times.timeEnd0}
                    disabled={!enforceTime}
                    onChange={(e) => {
                      setTimes(prev => ({
                        ...prev,
                        timeEnd0: e
                      }));
                      actionZoneModified.set(true);
                    }}
                    minutesStep={15}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
                <TimeIcon />
              </StartEndDate>
            </DateWrapper>
            <DateWrapper>
              <StartEndDate>
                <p className="label">{t("Start")}</p>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MobileTimePicker
                    value={times.timeStart1}
                    disabled={!enforceTime}
                    onChange={(e) => {
                      setTimes(prev => ({
                        ...prev,
                        timeStart1: e
                      }));
                      actionZoneModified.set(true);
                    }}
                    minutesStep={15}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
                <TimeIcon />
              </StartEndDate>
              <StartEndDate>
                <p className="label">{t("End")}</p>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <MobileTimePicker
                    value={times.timeEnd1}
                    disabled={!enforceTime}
                    onChange={(e) => {
                      setTimes(prev => ({
                        ...prev,
                        timeEnd1: e
                      }));
                      actionZoneModified.set(true);
                    }}
                    minutesStep={15}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
                <TimeIcon />
              </StartEndDate>
            </DateWrapper>

            <p className="timeValidationMessage">{vaildationMsg}</p>
          </WorkSection>
          <SaveActionWrapper>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {showNearingWarning && (
                <Tooltip title={nearingWarningMessage}>
                  <WarningIcon
                    sx={{
                      color: '#d32f2f',
                      fontSize: '20px',
                      cursor: 'pointer'
                    }}
                  />
                </Tooltip>
              )}
              <Button
                variant="outlined"
                disabled={!actionZoneModified.get() || isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role) || isOverAnyLimit}
                className={actionZoneModified.get() && !isOverAnyLimit && !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role)) ? "active" : "disabled"}
                onClick={() => handleSaveZone()}
              >
                {addActionZonePolygon.get() ? t("Save") : t("Update")}
              </Button>
            </div>
            <Button variant="outlined" className={!isRestrictedUser ? "active cancel-btn" : "disabled cancel-btn"}
              onClick={() => cancelActionZoneEdit.set((prev) => !prev)} disabled={isRestrictedUser}
              sx={{
                "&.Mui-disabled": {
                  color: "#d6d6d6   !important",
                  borderColor: "#d6d6d6   !important",
                },
              }}>
              {t("Cancel")}
            </Button>
            <Button
              variant="outlined"
              className={!isRestrictedUser ? "active cancel-btn" : "disabled cancel-btn"}
              onClick={() => setOpenDeletePopup(true)}
              disabled={isRestrictedUser}
              sx={{
                "&.Mui-disabled": {
                  color: "#d6d6d6  !important",
                  borderColor: "#d6d6d6  !important",
                },
              }}
            >
              {t("Delete")}
            </Button>
            {editActionZonePolygonData?.get()?.actionZoneInfo?.IsGeofence &&
              <Button className="cancel-btn" onClick={handleResetGeofenceZone}>
                {t("Reset")}
              </Button>
            }
          </SaveActionWrapper>
          <div>
            {t("Id")}: {actionZoneId.get() ? actionZoneId.get() : 0} {t("Vertices")}:{" "} 
            <span style={{
              color:isOverVertexLimit || isNearVertexLimit ? '#d32f2f' : 'inherit',
              fontWeight:'bold'
            }}>
              {actionZoneVertexCount.get()}/{actionZoneLimits.MAX_VERTICES}
            </span>
            {isAzLimitSite&&(
              <>
                {" "}{t("Zones")}:{" "}
                <span style={{
                  color: isOverZoneLimit || isNearZoneLimit ? '#d32f2f' : 'inherit',
                  fontWeight:'bold'
                }}>
                  {totalActionZones}/{actionZoneLimits.MAX_ACTION_ZONES}
                </span>
              </>
            )}
          </div>
        </Container>
      ) : (
        <></>
      )}
      <Modal
        open={openDeletePopup}
        onClose={() => setOpenDeletePopup(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={deleteModalPopupStyle}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{editActionZonePolygonData?.get()?.actionZoneInfo?.IsGeofence ? t("Delete_the_Geofence") : t("Delete_this_Action_Zone?")}</p>

            <div className="action-btn">
              <button
                onClick={() => { handleDeleteZone(); }}
                className="primary"
              >
                {t("Yes")}
              </button>
              <button
                onClick={() => {
                  setOpenDeletePopup(false);
                }}
              >
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    </>
  );
});
export { ActionZonesSubNav };